import React from "react";
import styled from "styled-components";
import { style } from "./style";

const BackgroundElt = styled.div`
  position: absolute;
  top: ${style.vars.whitespace.xlarge};
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
`;

type Props = {
  url?: string;
  verticalPosition?: string;
  horizontalPosition?: string;
  color?: string;
};

export const Background: React.FC<Props> = ({
  url,
  verticalPosition = "center",
  horizontalPosition = "center",
  color = style.colors.primaryBackground,
}) => {
  return (
    <BackgroundElt
      style={{
        backgroundImage: `${url ? `url(${url})` : undefined}`,
        backgroundPosition: `${horizontalPosition} ${verticalPosition}`,
        backgroundColor: color,
      }}
    />
  );
};
